// src/components/MainBox.js
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "../commonLogin.css";
import Login from "../Login/index";
import OtpAuth from "../OtpAuth";
import ForgotPassword from "../ForgotPassword/index";
import Success from "../Success/index";
import UpdatePassword from "../UpdatePassword/index";
import ChangePassword from "../ChangePassword";
import Register from "../Register";
import Homepage from "../../components/home/Homepage";
import { Box, Paper, Typography, Container, Grid, Fade } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const MainBox = () => {
  const location = useLocation();
  const [highlightedLink, setHighlightedLink] = useState(0);

  const links = ["GoStandOut", "GoLearn", "GoToTest", "GoSolveCode"];

  const handleLinkClick = (index) => {
    setHighlightedLink(index);
  };

  // Get the component to render based on the current path
  const getComponent = () => {
    switch (location.pathname) {
      case "/register":
        return <Register />;
      case "/login":
        return <Login />;
      case "/forgotPassword":
        return <ForgotPassword />;
      case "/otpVerification":
        return <OtpAuth />;
      case "/updatePassword":
        return <UpdatePassword />;
      case "/success":
        return <Success />;
      case "/changePassword":
        return <ChangePassword />;
      case "/":
      default:
        return <Homepage />;
    }
  };

  return (
    <Container maxWidth="xl" disableGutters>
      <Box
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f9f9f9, #e3e3e3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: 2, md: 4 },
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            maxWidth: "1200px",
            overflow: "hidden",
            borderRadius: "24px",
            background: "#ffffff",
            border: "1px solid rgba(0,0,0,0.08)",
            boxShadow: "0 30px 80px rgba(0,0,0,0.12)",
          }}
        >
          <Grid container>
            {/* Left Side - Content */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                position: "relative",
                p: { xs: 4, md: 3 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                background: "linear-gradient(135deg, #ffffff, #f7f7f7)",
              }}
            >
              {/* Decorative elements */}
              <Box
                sx={{
                  position: "absolute",
                  width: 280,
                  height: 280,
                  borderRadius: "50%",
                  // background:
                  //   "radial-gradient(circle, rgba(229,157,2,0.15), transparent 70%)",
                  // top: -100,
                  // left: -100,
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  width: 200,
                  height: 200,
                  borderRadius: "50%",
                  background:
                    "radial-gradient(circle, rgba(229,157,2,0.1), transparent 70%)",
                  bottom: -60,
                  right: 40,
                }}
              />

              <Fade in={true} timeout={800}>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 800,
                      mb: 3,
                      lineHeight: 1.0,
                      background: "#334155",
                        // "linear-gradient(135deg, #e59d02 0%, #b08b84 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      padding:1
                    }}
                  >
                    Welcome to Strategic Hire
                  </Typography>

                  {/* <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 400,
                      color: "#374151",
                      marginBottom: 4,
                      maxWidth: "90%",
                      lineHeight: 1.4,
                      fontSize: "16px",
                    }}
                  >
                    Transforming Job Searches into Success Stories - Because
                    Your Resume Deserves Intelligence.
                  </Typography> */}

<Typography
  variant="h6"
  sx={{
    fontWeight: 400,
    color: "#374151",
    marginBottom: 4,
    maxWidth: "90%",
    lineHeight: 1.4,
    fontSize: "16px",
  }}
>
  Transforming Job Searches into{" "}
  <Box component="span" sx={{ color: "rgb(37, 99, 235)", fontWeight: 600 }}>
    Success Stories
  </Box>{" "}
  — Because Your Resume Deserves{" "}
  <Box component="span" sx={{ color: "rgb(37, 99, 235)", fontWeight: 600 }}>
    Intelligence
  </Box>.
</Typography>




<Box sx={{ mt: 3 }}>
  {[
    "AI-Powered Resume Screening",
    "Smart Candidate Matching",
    "Faster Hiring Decisions",
  ].map((item, index) => (
    <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
      <CheckCircleIcon sx={{ color: "rgb(37, 99, 235)", mr: 1 }} />
      <Typography sx={{ color: "#374151", fontWeight: 500 }}>
        {item}
      </Typography>
    </Box>
  ))}
</Box>

                  {/* Feature points */}
                  <Box sx={{ mt: 4 }}>
                    <img
                      src="/assests/images/login1.jpg"
                      alt="Strategic Hire"
                      style={{ width: "500px", borderRadius: "10px", boxShadow: "0 10px 30px rgba(0,0,0,0.1)" }}
                    />
                  </Box>
                </Box>
              </Fade>
            </Grid>

            {/* Right Side - Form */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // background: "linear-gradient(135deg, #f2ac16 0%, #b37a01 100%)",
                background: "#334155",
                borderRadius: { xs: 0, md: "0 24px 24px 80px" },
                overflow: "hidden",
              }}
            >
              {/* Background elements */}
              <Box
                sx={{
                  position: "absolute",
                  width: 260,
                  height: 260,
                  borderRadius: "50%",
                  // background:
                  //   "radial-gradient(circle, rgba(229,157,2,0.25), transparent 70%)",
                  // top: "15%",
                  // right: "-120px",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  width: 180,
                  height: 180,
                  borderRadius: "50%",
                  // background:
                  //   "radial-gradient(circle, rgba(229,157,2,0.2), transparent 70%)",
                  // bottom: "10%",
                  // left: "10%",
                }}
              />

              {/* Decorative lines */}
              {[45, 135, 225, 315].map((angle, index) => (
                <Box
                  key={index}
                  sx={{
                    position: "absolute",
                    width: "150px",
                    height: "2px",
                    background:
                      "linear-gradient(90deg, rgba(0, 224, 255, 0.2), rgba(0, 0, 0, 0))",
                    transform: `rotate(${angle}deg)`,
                    top: ["20%", "70%", "30%", "80%"][index],
                    left: ["70%", "20%", "80%", "30%"][index],
                  }}
                />
              ))}

              {/* Forms container */}
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "420px",
                  px: { xs: 3, sm: 4 },
                  py: 4,
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #f9f9f9, #e3e3e3)",
                  backdropFilter: "blur(14px)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
                  zIndex: 2,
                }}
              >
                {getComponent()}
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
};

export default MainBox;
